import { Link } from 'react-router'

const NotFound = () => (
  <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-600 to-green-600 px-4">
    <div className="text-center">
      <h1 className="text-9xl font-extrabold tracking-widest text-white">
        404
      </h1>
      <div className="absolute rotate-12 rounded bg-green-500 px-2 text-sm">
        Page Not Found
      </div>
      <p className="mt-8 mb-4 text-xl text-white">
        Sorry, we couldn't find what you're looking for.
      </p>
      <p className="mb-8 text-gray-200">
        The page might have been removed or you mistyped the URL.
      </p>

      <div className="mt-6">
        <Link
          to="/"
          className="inline-block transform rounded-full bg-white px-8 py-3 font-semibold text-blue-600 shadow-lg transition duration-300 ease-in-out hover:scale-105 hover:bg-gray-100"
        >
          Take Me Home
        </Link>
      </div>
    </div>
  </main>
)

export default NotFound
